module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"previous":"Précédent","next":"Suivant"},"en":{"previous":"Previous","next":"Next"},"es":{"previous":"Anterior","next":"Siguiente"},"de":{"previous":"Zurück","next":"Vorwärts"},"it":{"previous":"Precedente","next":"Successive"},"nl":{"previous":"Vorige","next":"Volgende"},"pt":{"previous":"Anterior","next":"Seguinte"}}')
  delete Component.options._Ctor
}
